import React, {useEffect, useState} from 'react'
import WplFullpageForm from "../../components/fullpage-form/WplFullpageForm";
import WplInput from "../../components/wpl-input/WplInput";
import WplButton from "../../components/wpl-button/WplButton";
import WplSelectInput from "../../components/wpl-select-input/WplSelectInput";
import {useNavigate, useParams} from "react-router-dom";
import {userAPI} from "../../api";
import {setAuthToken} from "../../auth/user-service";
import termsUKEUROW from '../lightning/lightning-support/termsUKEUROW'
import termsUS from '../lightning/lightning-support/termsUS'
import './invitation-page.css'

// Both versions are offered; the invitee picks the one to read. Only the fact
// that the Terms of Service were accepted is recorded, not which version.
const TERMS_VERSIONS = {
    'UK / Europe / Rest of World': termsUKEUROW,
    'United States': termsUS,
}
const DEFAULT_TERMS_VERSION = 'UK / Europe / Rest of World'

export default function InvitationPage(props) {
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [error, setError] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [authenticated, setAuthenticated] = useState(false)

    const [tokenValidity, setTokenValidity] = useState(null);
    const [requiresTerms, setRequiresTerms] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [termsVersion, setTermsVersion] = useState(DEFAULT_TERMS_VERSION);

    let {token} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) return;
        userAPI.checkInvitationToken(token)
            .then(res => {
                setRequiresTerms(Boolean(res?.requires_terms_acceptance))
                setTokenValidity(true)
            })
            .catch(e => setTokenValidity(e?.response?.data || 'Could not validate the invitation. Please try again later.'))
    }, [token]);

    useEffect(() => {
        if (authenticated) navigate('/')
    }, [authenticated, navigate]);

    if (!token) {
        return <div className='error-wrapper'><h4>No token. Close this page and open the link from your email
            again.</h4></div>
    }

    function submit() {
        if (password !== rePassword) {
            setError('Passwords do not match')
            return;
        }
        setError('')
        setSubmitting(true)
        userAPI.acceptInvitation(token, password, requiresTerms && termsAccepted).then(t => {
            setAuthToken(t)
            setAuthenticated(true)
        }).catch(e => {
            setError(e?.response?.data || 'Could not create your account. Please try again.')
            setSubmitting(false)
        })
    }

    const showTermsStep = tokenValidity === true && requiresTerms && !termsAccepted
    const showPasswordStep = tokenValidity === true && !showTermsStep

    if (showTermsStep) {
        return (<div className='invitation-page terms-step'>
            <WplFullpageForm subtitle='Accept the Terms of Service to continue' className='terms-segment'>
                <p className='terms-intro'>
                    Before setting up your password, please read and accept the LASSIE Terms of Service.
                    The US version applies to customers contracting in the United States; the
                    UK / Europe / Rest of World version applies to all other customers.
                </p>
                <WplSelectInput
                    label='Terms of Service version'
                    options={Object.keys(TERMS_VERSIONS)}
                    value={termsVersion}
                    onChange={setTermsVersion}
                    containerClassName='terms-version-select'/>
                <div className='terms-doc' dangerouslySetInnerHTML={{__html: TERMS_VERSIONS[termsVersion]}}/>
                <WplButton value='I ACCEPT THE TERMS OF SERVICE' onClick={() => setTermsAccepted(true)}/>
            </WplFullpageForm>
        </div>)
    }

    return (<div className='invitation-page'>
        <WplFullpageForm subtitle='Set a password for your new account'>
            {showPasswordStep && <WplInput title='Password' type='password' value={password} onChanged={setPassword}/>}
            {showPasswordStep && <WplInput title='Re-type password' type='password' value={rePassword} onChanged={setRePassword} error={error}/>}
            {showPasswordStep && <WplButton value='SUBMIT' onClick={submit} loading={submitting}/>}

            {tokenValidity !== true && tokenValidity !== null && <p>{tokenValidity}</p>}
            {tokenValidity !== true && tokenValidity !== null && <a href='/login'>Click here to login</a>}
        </WplFullpageForm>
    </div>)
}
